<template>
<div class="main">
	<!-- 海尔经销商防控计划 -->
	<div class="title">{{res.productName}}</div>
	<Steps :current="2" style="margin:20px auto; width:700px;padding-left:116px">
        <Step title="填写投保信息"></Step>
        <Step title="确认保单"></Step>
        <Step title="支付保单"></Step>
    </Steps>
    <div class="order">
    	<div class="order-title">订单信息</div>
    	<Table :columns="columns" border :data="orderData"></Table>
    </div>
	<!-- 20260107需求隐藏扫码支付功能 -->
    <!-- <div class="pay" v-show="res.payUrl">
    	<div class="code">
    		<div id="qrcode"></div>
    		<p>请使用微信扫码支付</p>
    	</div>
    </div> -->
	<div class="center fz16">
			<template>当天24时前未完成支付订单，将自动关闭。</template>
		</div>
		<Row class="mt15">
			<Col span="14" offset="5">
				<div class="publicPay mt10">
					<div class="form">
						<template>
							<p>
								<span class="form-label">账户名：</span>
								<span class="form-value">中国人民财产保险股份有限公司青岛市分公司</span>
							</p>
							<p>
								<span class="form-label">开户行：</span>
								<span class="form-value">中国工商银行青岛市南支行</span>
							</p>
							<p>
								<span class="form-label">账号：</span>
								<span class="form-value">9558853803000767635</span>
							</p>
							<p>
								<span class="form-label">行号：</span>
								<span class="form-value">102452000037 (公对公支付)</span>
							</p>
						</template>
						<p class="mt15">
							<span class="form-label"></span>
							<UploadFile @on-success="handleSuccess" type="select">
								<Button type="primary">上传支付凭证</Button>
							</UploadFile> 
							<a @click="openOriginFile(res.payVoucherUrl)" v-if="res.payVoucherUrl">查看文件</a>
						</p>
						<p class="mt15">
							<span class="form-label"></span>
							<Button type="success" @click="confirmUpload" :disabled="!Boolean(res.payVoucherUrl)">提交凭证</Button>
						</p>
					</div>
				</div>
			</Col>
		</Row>
</div>
</template>
<script>
import QRCode from 'qrcodejs2'
import track from "@/mixin/track";
import UploadFile from '@/components/common/UploadFileImg'
export default {
	mixins:[track],
	components:{UploadFile},
	data () {
		return {
			columns:[
				{
                    title: '产品名称',
                    key: 'productName',
                    render:(h, params) =>{
	                    return h('strong', {
	                        style: {
							    fontSize: '16px'
							},
	                    },params.row.productName)
                    }
                },
                {
                    title: '订单号',
                    key: 'orderNo'
                },
                {
                    title: '订单金额',
                    key: 'price',
                    width:150,
                },
                {
                	title: '支付金额',
                    key: 'payPrice',
                    width:200,
                    render:(h, params) =>{
	                    return h('span', {
	                        style: {
							    color: 'red',
							    fontSize: '25px'
							},
	                    },params.row.payPrice)
                    }
                }
			],
			orderData:[],
			res:{},
			clock:undefined,
			flag:true,
		}
	},
	created () {
		this.getPayInfo()
	},
	mounted () {
		// 回溯 开始录制
		this.$nextTick(this.startRecord);
	},
	methods:{
		// 上传成功payType
		handleSuccess(val){
			this.$set(this.res,'payVoucherUrl',val.url)
		},
		/*获取支付信息*/
		getPayInfo () {
			this.$post('/insurance2b/insurance/queryPayInfo',res=>{
				this.res = res.data;
				this.orderData.push({
					...res.data,
					price:res.data.premium+'元',
					payPrice:res.data.premium+'元'
				})
				// this.getCode();
				// this.checkStatus() //检查支付状态
			},{
				orderNo:this.$route.query.orderNo
			})
		},
		getCode () {
			let qrcode = new QRCode('qrcode', {
		        width: 200,
		        height: 200, // 高度
		        text: this.res.payUrl // 二维码内容
		    })
		},
		/*检查支付状态*/
		checkStatus () {
			let that = this;
			this.clock=setInterval(()=>{
				if(that.flag){
					that.flag=false;
					that.$postNo('/insurance2b/insurance/queryPayStatus',async res=>{
						that.flag=true;
						if(res.data.orderStatus==3){
							that.toast("订单非待支付状态","error");
							clearInterval(that.clock);
							that.res.payUrl = "";
							return;
						}
						if(res.data.orderStatus==2){
							clearInterval(that.clock);
							const { orderNo="" } = that.$route.query;
							// 回溯 停止录制
							await this.stopRecord({
								policy_id: orderNo
							});
							if(that.res.productCode=="GZZRGH"){
								window.location.href = `/haier.html#/order/detail/${that.res.policyId}/${res.data.type}?orderNo=${orderNo}`
							}else{
								window.location.href = `/haier.html#/order/detail/${that.res.policyId}/${res.data.type}`
							}
						}
					},{
						orderNo:that.$route.query.orderNo
					})
				}
			},1000)
		},
		confirmUpload(){
			this.confirm('确定提交已上传凭证？',()=>{
				this.$axios.post('/specialityStores/uploadPayVoucher.json.all',{
					orderNo:this.$route.query.orderNo,
					payVoucherUrl:this.res.payVoucherUrl
				}).then(async res=>{
					if(res.code==10000000){
						// 回溯 停止录制
						await this.stopRecord({
							policy_id: this.$route.query.orderNo
						});
						this.checkStatus() //检查支付状态
					}
				});
			})
		}
	}
}
</script>
<style scoped lang="less">
	.main{
		padding: 20px 30px;
	}
	.order-title{
		font-size: 14px;
		margin-bottom: 10px;
	}
	.pay{
		margin-top: 20px;
		display:flex;
		justify-content: center;
		text-align:center;
	}
	.code>p{
		margin-top: 15px;
	}
	.order-title {
		// font-size: 14px;
		margin-bottom: 10px;
	}
	.center {
		font-size: 25px;
		font-weight: bold;
		margin-top: 15px;
		color: #ff6600;
	}
	.fz16{
		font-size: 1.142857em;
	}
	.code > p {
		margin-top: 15px;
	}
	.price {
		font-size: 1.142857em;
		&-label {
			width: 7em;
			display: inline-block;
			line-height: 2;
			text-align: right;
			font-size: 1.142857em;
			&.small{
				width: 92px;
			}
		}
		&-value {
			color: red;
			font-size: 1.142857em;
			&.disabled{
				color: #999;
				text-decoration: line-through;
			}
		}
	}
	.form {
		margin-top: 10px;
		// font-size: 14px;
		&-label {
			width: 7em;
			display: inline-block;
			line-height: 2;
			text-align: right;
		}
		.red {
			color: red;
		}
	}
	.publicPay {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		.note {
			// font-size: 12px;
		}
	}
	.cModel{
		width:100%;
		color: rgba(16, 16, 16, 1);
		// font-size: 14px;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/pages/common/components/pay/index.vue